module.exports = __webpack_public_path__ + "img/peruanos-por-el-kambio.22782733.png";